
const overloaded = 'Punkt jest przepełniony';
export default {
    FILLED: overloaded,
    Overloaded: overloaded,
    Disabled: 'Punkt jest wyłączony',
};
